import { HStack, Link, Pressable } from '@ayble-health/dashboard-components';
import React from 'react';
import { Flex, Image } from '@chakra-ui/react';
import { useAuth } from '../../hooks';

function HeaderNav({
  changePage = () => {},
  hideBack = false,
  page,
  setParentPage = null,
  pageLinks = [],
}) {
  const { isAuthenticated, signOut } = useAuth();

  const backBttn = '../chevron-left-white.png';

  const logo = './../FA__ayble_health_Logo_Isabelline_white.png';
  const logoDark = './../FA__ayble_health_Logo_Isabelline.png';
  const styles = {
    navIcon: {
      backgroundSize: 'contain',
      maxHeight: '32px',
      width: '44px',
      marginTop: '4px',
      resizeMode: 'contain',
      zIndex: 2,
    },
    logo: {
      backgroundSize: 'contain',
      maxHeight: '56px',
      resizeMode: 'contain',
    },
    backBttn: {
      width: 32,
      height: 32,
    },
  };

  const handlePageChange = () => {
    if (!!changePage) {
      changePage();
      return;
    }

    if (page === 1) {
      // skip old login and go to the home page
      setParentPage(-2);
    } else setParentPage((currPage) => currPage - 1);
  };

  const hasLinksToShow = !!pageLinks.length;
  const isDark = !hasLinksToShow;

  return (
    <Flex
      alignItems={'center'}
      backgroundColor={hasLinksToShow ? 'muted.100' : 'secondary.500'}
      flexDirection={isAuthenticated ? 'row-reverse' : 'row'}
      h={'64px'}
      justifyContent={'space-between'}
      position={'relative'}
      px={'2em'}
      py={0}
      style={{ isolation: 'isolate' }}
    >
      {isAuthenticated && (
        <Link
          fontSize={'xs'}
          color={isDark ? 'light.100' : 'secondary.600'}
          _hover={{
            color: isDark ? 'primary.100' : 'secondary.600',
          }}
          onClick={() => signOut({ returnTo: window.location.origin })}
        >
          Logout
        </Link>
      )}

      {hasLinksToShow && (
        <HStack w={300} justifyContent={'space-between'}>
          {pageLinks.map((pageLink, i) => (
            <Link
              key={`${pageLink}-${i}`}
              color={'secondary.600'}
              textTransform={'none'}
              textDecoration={'none'}
              fontWeight={'medium'}
              _hover={{
                textDecoration: 'underline',
                fontWeight: 'medium',
              }}
              href={pageLink.href}
            >
              {pageLink.label}
            </Link>
          ))}
        </HStack>
      )}

      <Image
        size={'md'}
        style={{
          ...styles.logo,
          ...(isDark && {
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
          }),
        }}
        src={isDark ? logo : logoDark}
        alt="Ayble Health logo"
        onClick={() => window.open('https://ayblehealth.com', '_blank')}
      />

      {!hasLinksToShow && page !== 0 && page !== -2 && (
        <Pressable onClick={handlePageChange}>
          {!hideBack && (
            <Image
              zIndex="1"
              alt="back button"
              source={backBttn}
              style={styles.backBttn}
            />
          )}
        </Pressable>
      )}

    </Flex>
  );
}

export default HeaderNav;
